<template>
    <div class="flex-grow overflow-auto">
        <!-- Lista de Itens -->
        <div v-if="showData()">
            <div class="divide-y divide-gray-100">
                <div v-for="row in dataRows" :key="row.id"
                    class="px-4 py-3 hover:bg-gray-50 cursor-pointer transition-colors"
                    :class="searchSelected(row.id) ? 'bg-gray-50' : ''"
                    @click="$emit('open:item', row)">

                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-3">
                            <!-- Status indicator -->
                            <div class="w-2 h-2 rounded-full" :class="{
                                'bg-green-500': row.status === 'open',
                                'bg-gray-400': row.status === 'closed',
                                'bg-yellow-400': row.status === 'waiting',
                            }"></div>

                            <!-- Canal logo -->
                            <img :src="getLogo(row.channel)" class="h-5 w-5 opacity-60" />

                            <div>
                                <p class="text-sm font-medium text-gray-700">
                                    {{ (row.messages && row.messages.length) || '0' }} mensagens
                                </p>
                                <p class="text-[10px] text-gray-400">
                                    {{ formatDate(row.created_at) }}
                                </p>
                            </div>
                        </div>

                        <div class="text-right">
                            <p class="text-[10px] text-gray-500 font-medium">
                                {{ calculateTotalTime(row.created_at, row.updated_at) }}
                            </p>
                            <!-- Botões -->
                            <div v-if="buttons" class="mt-1">
                                <slot name="buttons" :row="row" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Caso não haja dados -->
        <div v-else class="flex items-center justify-center h-full py-12">
            <div class="text-center text-gray-400">
                <p class="text-sm font-medium">Nenhuma conversa</p>
                <p class="text-xs mt-1">O histórico aparecerá aqui.</p>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: "ListChats",
    props: {
        buttons: {
            type: Boolean,
            required: false,
            default: false,
        },
        dataRows: {
            type: Object,
            required: false,
        },
        selected: {
            type: Array,
            required: false,
        },
    },
    emits: ["open:item", "open:item_area", "open:remove"],
    methods: {
        showData() {
            return this.dataRows?.length > 0;
        },
        searchSelected(id) {
            return this.selected.includes(id);
        },
        formatDate(date) {
            if (!date) return "N/A";
            const options = { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" };
            return new Date(date).toLocaleDateString("pt-BR", options);
        },
        calculateTotalTime(start, end) {
            if (!start || !end) return "N/A";
            const startTime = new Date(start);
            const endTime = new Date(end);
            const diffInMs = endTime - startTime;

            if (diffInMs < 0) return "Inválido";

            const diffInMinutes = Math.floor(diffInMs / 60000);
            const hours = Math.floor(diffInMinutes / 60);
            const minutes = diffInMinutes % 60;

            return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
        },
        getLogo(channel) {
            const logos = {
                whatsapp_api: "/imgs/logos/whatsapp_business.png",
                whatsapp_web: "/imgs/logos/whatsapp.svg",
                messenger: "/imgs/logos/messenger.svg",
                instagram: "/imgs/logos/instagram.svg",
                widget: "/imgs/logos/chat.png",
            };
            return logos[channel] || "/imgs/logos/chat.png";
        },
    },
};
</script>
